import { Holders } from 'civil-status/view-models/step-form';
import { ISTAT_MILANO, ISTAT_MILANO_2 } from 'shell/constants/istat-milano';

export const isResidenceMilano = (holder?: Holders): boolean => {
  if (!holder) {
    // se non viene passato nulla torna che il soggetto non è residente
    return false;
  }

  return holder?.idComuneResidenza === ISTAT_MILANO || holder?.idComuneResidenza === ISTAT_MILANO_2;
};
